export default __webpack_public_path__ + "7d52a6cd4490600453204ddf188120d9.svg";